import { render } from "./CompletedMatchScore.vue?vue&type=template&id=963fe15c&ts=true"
import script from "./CompletedMatchScore.vue?vue&type=script&lang=ts"
export * from "./CompletedMatchScore.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__